import { ROUTES } from '../../routes/consts';
import { TabKey } from './types';

export const TAB_KEYS = {
  ANALYTICS: 'analytics',
  TRANSACTIONS: 'transaction-history',
  MANAGE_SUBSCRIPTION: 'manage-subscription',
} as const;

export const TAB_ROUTES: Record<TabKey, string> = {
  [TAB_KEYS.ANALYTICS]: ROUTES.BILLING_ANALYTICS,
  [TAB_KEYS.TRANSACTIONS]: ROUTES.BILLING_TRANSACTION_HISTORY,
  [TAB_KEYS.MANAGE_SUBSCRIPTION]: ROUTES.BILLING_MANAGE_SUBSCRIPTION,
};

export const CARD_KEYS = {
  CREDITS_REMAINING: 'credits-remaining',
  REVIEWS_THIS_PERIOD: 'reviews-this-period',
  PRS_REVIEWED: 'prs-reviewed',
  RENEWAL: 'renewal',
} as const;

export type CardKey = (typeof CARD_KEYS)[keyof typeof CARD_KEYS];

export const COLUMN_IDS = {
  DATE: 'date',
  PR: 'pr',
  REVIEW_TYPE: 'reviewType',
  CREDITS: 'credits',
  COMPLEXITY: 'complexity',
  MODE: 'reviewMode',
} as const;

/**
 * Number format for the transactions Credits column when fractional credits are
 * shown. Decimals only when the value has them: `10` stays `10`, `0.4` stays
 * `0.4`, `212.826` becomes `212.83`. Nothing is padded.
 */
export const FRACTIONAL_CREDITS_FORMAT: Intl.NumberFormatOptions = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
};

/**
 * Minimum monthly overage cap, in whole USD, that the editor allows the user to
 * set. The backend floor is 0 (a hard block); the UI requires a usable ceiling.
 */
export const OVERAGE_CAP_MIN_USD = 0;

export const INITIAL_REVIEWS_ROWS_COUNT = 20;
export const CHART_SKELETON_BAR_HEIGHTS = [
  '60%',
  '80%',
  '45%',
  '90%',
  '70%',
  '55%',
  '85%',
];

export const DEFAULT_DATE_RANGE_DAYS = 30;
